"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown/index"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ActionButtonsUserMember = function ActionButtonsUserMember(_ref) {
  var groupId = _ref.groupId,
      isUserSubscribed = _ref.isUserSubscribed,
      unsubscribe = _ref.unsubscribe,
      subscribe = _ref.subscribe,
      leaveGroup = _ref.leaveGroup;
  return (0, _preact.h)("div", {
    className: "group-details_hero__user-actions"
  }, (0, _preact.h)(_index.default, {
    size: "S",
    align: "right",
    popupName: "group-actions-list",
    trigger: (0, _preact.h)(_Button.default, {
      type: "button",
      size: "medium",
      oldStyle: true,
      className: (0, _classnames.default)('btn', 'btn--secondary', 'group-details_hero__user-action-dropdown-btn')
    }, (0, _preact.h)(_phrase.default, {
      p: "groups.you.are.member"
    }), (0, _preact.h)(_ChevronDown.default, {
      className: "icon-dropdown",
      width: 24
    }))
  }, (0, _preact.h)(_index.DropdownItem, null, isUserSubscribed ? (0, _preact.h)("button", {
    className: "user-action__group-subscription-btn",
    onClick: unsubscribe
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.unsubscribe.from.notifications"
  })) : (0, _preact.h)("button", {
    className: "user-action__group-subscription-btn",
    onClick: subscribe
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.subscribe.to.notifications"
  }))), (0, _preact.h)(_index.DropdownItem, {
    type: "alert"
  }, (0, _preact.h)("button", {
    className: "user-action__leave-group-btn",
    onClick: leaveGroup
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.leave.group"
  })))), (0, _preact.h)("a", {
    type: "button",
    className: (0, _classnames.default)('btn--cta', 'create-group-topic-btn', 'is-hidden-S'),
    href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new?fid=".concat(groupId))
  }, (0, _preact.h)(_phrase.default, {
    p: "main.navigation.add_topic"
  })));
};

var GroupActionButtons = function GroupActionButtons(_ref2) {
  var joinGroup = _ref2.joinGroup,
      isLoading = _ref2.isLoading,
      isUserMember = _ref2.isUserMember,
      groupId = _ref2.groupId,
      isUserSubscribed = _ref2.isUserSubscribed,
      unsubscribe = _ref2.unsubscribe,
      subscribe = _ref2.subscribe,
      leaveGroup = _ref2.leaveGroup;
  return (0, _preact.h)(_preactPortal.default, {
    key: "new-button",
    into: ".group-details-page_action-buttons"
  }, isUserMember ? (0, _preact.h)(ActionButtonsUserMember, {
    groupId: groupId,
    isUserSubscribed: isUserSubscribed,
    unsubscribe: unsubscribe,
    subscribe: subscribe,
    leaveGroup: leaveGroup
  }) : (0, _preact.h)(_Button.default, {
    type: "button",
    className: "btn--cta btn",
    isLoading: isLoading,
    onClick: joinGroup,
    oldStyle: true
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.join.group"
  })));
};

var _default = GroupActionButtons;
exports.default = _default;